import RoundedButton from "@/components/rounded-button"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"

export interface AddProcessBarProps {
  className?: string
  shift: string
  hideBtn?: boolean
  onClickAdd?: () => void
}

export default function AddProcessBar({
  className,
  shift,
  hideBtn,
  onClickAdd,
}: AddProcessBarProps) {
  return (
    <div
      className={cn(
        "bg-band-fill p-4 flex justify-between items-center z-10",
        className
      )}
    >
      <div className="flex flex-col gap-1">
        <h2 className="font-medium text-label-text text-sm">Shift</h2>
        <div className="text-base text-button-black font-medium">{shift}</div>
      </div>

      {!hideBtn && (
        <RoundedButton
          icon={<Icon name="Plus" className="size-4" />}
          onClick={onClickAdd}
        >
          Process
        </RoundedButton>
      )}
    </div>
  )
}
